import { render, staticRenderFns } from "./userTabs.vue?vue&type=template&id=288490a9"
import script from "./userTabs.vue?vue&type=script&lang=js"
export * from "./userTabs.vue?vue&type=script&lang=js"
import style0 from "~/assets/css/login/userTabs.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports